import React from 'react';
import { Accordion } from 'react-bootstrap';
import Manual from '../components/Manual/Manual';
import { WalletLogos } from 'lb-components/src/stories/assets/icons/payment';
import { Toast } from 'lb-store';
const withdrawFee = 6;
const walletIds = {
  deposit: [
    {
      id: 2,
      name: 'TbcPay',
      limit: {
        min: '0.5',
        max: '1 500',
        maxAmount: '200 000',
      },
    },
  ],
  withdraw: [
    { id: 1, name: 'EMoney', limit: { min: '1', max: '5 000', fee: withdrawFee,maxAmount: '50 000', } },
    {
      id: 3,
      name: 'LeaderPay',
      limit: { min: '1', max: '3 000', fee: withdrawFee,maxAmount: '200 000', },
    },
  ],
};

const Wallets = ({ User, platform, actionType, payment, t, ...props }) => {
  const submitHandler = (item, callback) => {
    if (item.type === 'deposit') {
      switch (item.provider) {
        case 'TbcPay':
          setTimeout(() => {
            console.log(User);
            window.open(
              `https://tbcpay.ge/services/totalizatorebi-kazino-lataria/liderbet/${User.data.pin}`,
              '_blank'
            );
          }, 10);
      }
    } else {
      let params = {};

      switch (item.provider) {
        case 'emoney':
          params = {
            vendor: 'emoney',
            cardid: item.cardId,
            amount: item.amount,
            sms: item?.sms,
          };
          break;
        case 'allpayway':
          params = {
            vendor: 'allpayway',
            amount: item.amount,
            sms: item?.sms,
          };

          break;
      }
      params['loader'] = item.loader;
      payment.withdraw(params).then((response) => {
        if (response.status) {
          callback({ confirm: false, sms: '' });
          Toast.show({
            type: 'success',
            content: t('ტრანზაქცია წარმატებით განხორციელდა'),
          });
        } else {
          if (response?.data?.code === 'sms') {
            callback({ confirm: true, sms: response?.data?.desc });
          } else {
            if (item?.confirm) {
              callback({ sms: response?.data?.desc });
            } else {
              Toast.show({
                type: 'error',
                content: response?.data?.desc,
              });
            }
          }
        }
      });
    }
  };

  return (
    <Accordion>
      {walletIds[actionType].map((item) => (
        <Manual
          actionType={actionType}
          key={item.id}
          eventKey={item.id}
          type={'wallet'}
          platform={platform}
          item={item}
          id={item.id}
          logo={WalletLogos[item.name]}
          style={{ marginBottom: '1rem' }}
          submit={submitHandler}
          t={t}
        />
      ))}
    </Accordion>
  );
};

export default Wallets;
